var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1.9V2.1V2.5H1.6H0V4.1V6.5V8.1V14.9V16.5H1.6H14.4H16V14.9V8.1V6.5V4.1V2.5H14.4H13.0004V2.1V1.9V0.5H11.4004V1.9V2.1V2.5H4.6V2.1V1.9V0.5H3V1.9ZM14.4 6.5V4.1H1.6V6.5H14.4ZM1.6 8.1V14.9H14.4V8.1H1.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.daf4c0d0eefb59536d5ced050941710f.svg";
export { ForwardRef as ReactComponent };